import React, { useEffect, useState } from 'react';
import { MobileHeaderWrapper } from './style';
import { useRouter } from 'next/router';

// Components
import SearchInput from 'components/common/SearchInput';
import MobileFiltering from './MobileFiltering';
import TuneIcon from '@mui/icons-material/Tune';

// Libs
import Translation from 'libs/Translation';
import ModalManager from 'libs/ModalManager';

const MobileHeader = ({ city, specialty, educationLevel, name, webConfig, cities, specialties, educationLevels, params, pageURL }) => {
    const router = useRouter();
    const [finalValue, setFinalValue] = useState(name);

    useEffect(() => {
        setFinalValue(name ?? '');
    }, [name])

    const handleChange = e => {
        const {value} = e.target;
        setFinalValue(value);
    }

    const handleSearchName = () => {
        let queries = '';
        Object.keys(params)?.forEach((k, index) => {
            queries = `${queries}${k}=${params[k]}`;	
            if (index < Object.keys(params)?.length - 1) {
                queries = `${queries}&`;
            }
        })
        if (finalValue) {
            queries = `${queries}name=${finalValue}`;
        }
        router.push(`${pageURL}?${queries}`);
    }

    const handleOpenFilteringModal = () => {
        ModalManager.show({
            content: <MobileFiltering 
                        webConfig={webConfig}
                        cities={cities}
                        specialties={specialties}
                        educationLevels={educationLevels}
                    />,
            title: Translation.t('label.filters'),
            maxWidth: 'sm',
            fullScreenMobile: true,
            fullScreenDesktop: false,
            hideCloseButton: false,
            closable: true,
        })
    }

    return (
        <MobileHeaderWrapper>
            <div
                className="input"
            >
                <SearchInput 
                    name='name'
                    value={finalValue}
                    handleChange={handleChange}
                    placeholder={Translation.t('label.doctor-name')}
                    searchButton
                    handleSearch={handleSearchName}
                />
            </div>
            <div
                className='filters'
                onClick={handleOpenFilteringModal}
            >
                <TuneIcon className='icon'/>
                {Translation.t('label.filters')}
                { (city && city !== 'IR' )
                || (specialty && specialty !== 'all')
                || (educationLevel && educationLevel !== 'all') ?   
                <span className='red-circle' />
                : null}
            </div>
        </MobileHeaderWrapper>  
    )
}

export default MobileHeader;
